<style scoped lang="scss" type="text/scss">
    .award-container-wrapper {
        width: 100%;

        .award-items {
            margin: -1rem 0 0 -1rem;
            display: flex;
            flex-wrap: wrap;

            .award-item {
                width: calc(20% - 1rem);
                height: 17rem;
                margin: 1rem 0 0 1rem;

                &.has-certificate:hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>

<template>
    <div class="award-container-wrapper">
        <template v-if="top4Award || top32Award">
            <block-divider>冠亚季军 & 标准奖项</block-divider>
            <div class="award-items">
                <award-item class="award-item has-certificate" c-icon="icon-huangguan" v-if="top4Award"
                            v-loading="certificateLoadingMap[top4Award.id]"
                            @click.native="obtainCertificate(top4Award)"
                            :award-name="top4Award.type_text" :competition-name="currentEnteredCompetitionName">
                </award-item>

                <award-item class="award-item has-certificate" c-icon="icon-honor" v-if="top32Award"
                            v-loading="certificateLoadingMap[top32Award.id]"
                            @click.native="obtainCertificate(top32Award)"
                            :award-name="top32Award.type_text" :competition-name="currentEnteredCompetitionName">
                </award-item>
            </div>
        </template>

        <template v-if="specialAwards && specialAwards.length > 0">
            <block-divider>单项奖</block-divider>
            <div class="award-items">
                <award-item class="award-item" c-icon="icon-jiangzhuang"
                            v-for="(award, index) in specialAwards" :key="index"
                            :award-name="award.name" :competition-name="currentEnteredCompetitionName">
                </award-item>
            </div>
        </template>
    </div>
</template>

<script>
    import AwardItem from './award-item';
    import BlockDivider from '@/components/divider/block';
    import {mapState} from 'vuex';
    import {TOP4_PLAYER_AWARD_TYPE_VALUES, TOP32_PLAYER_AWARD_TYPE_VALUES, PLAYER_AWARD_TYPE_MAP}
        from '@/constant/player-award-type';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            AwardItem,
            BlockDivider
        },
        data () {
            return {
                top4Award: null,
                top32Award: null,
                playerSpecialAwards: [],
                personalSpecialAwards: [],
                certificateLoadingMap: {}
            };
        },
        computed: {
            ...mapState('player', {
                currentEnteredPlayerId: state => state.currentEnteredPlayerId
            }),
            ...mapState('competition', {
                currentEnteredCompetitionId: state => state.currentEnteredCompetitionId,
                currentEnteredCompetitionName: state => state.currentEnteredCompetitionName,
            }),
            specialAwards () {
                let specialAward = [];
                if (this.playerSpecialAwards) specialAward = specialAward.concat(this.playerSpecialAwards);
                if (this.personalSpecialAwards) specialAward = specialAward.concat(this.personalSpecialAwards);
                return specialAward;
            }
        },
        methods: {
            obtainCertificate (playerAward) {
                this.$set(this.certificateLoadingMap, playerAward.id, true);
                this.$normalRequest('competition/obtainCertificateByPlayerAwardId', {
                    competition_id: this.currentEnteredCompetitionId,
                    player_award_id: playerAward.id
                }, '证书导出成功', true, this, 'updateRequesting').then(certificateInfo => {
                    window.open(certificateInfo.url);
                }).finally(_ => {
                    this.certificateLoadingMap[playerAward.id] = false;
                });
            },
            reloadAwards: _.throttle(function () {
                const currentEnteredPlayerId = this.currentEnteredPlayerId;
                const currentEnteredCompetitionId = this.currentEnteredCompetitionId;
                if (!currentEnteredPlayerId || !currentEnteredCompetitionId) return;
                this.$normalRequest('player/loadAwardsFilteredByCompetitionAndPlayer', {
                    competition_id: currentEnteredCompetitionId,
                    player_id: currentEnteredPlayerId
                }, false, false, this, 'requesting').then(awards => {
                    if (!awards || awards.length === 0) {
                        this.top4Award = null;
                        this.top32Award = null;
                    } else {
                        let top4Award = null;
                        let top32Award = null;
                        awards.forEach(award => {
                            award.type_text = PLAYER_AWARD_TYPE_MAP[award.type];
                            if (TOP4_PLAYER_AWARD_TYPE_VALUES.indexOf(award.type) >= 0) top4Award = award;
                            if (TOP32_PLAYER_AWARD_TYPE_VALUES.indexOf(award.type) >= 0) top32Award = award;
                        });
                        this.top4Award = top4Award;
                        this.top32Award = top32Award;
                    }
                });
                this.$normalRequest('player/loadSpecialPlayerAwardsFilteredByCompetitionAndPlayer', {
                    competition_id: currentEnteredCompetitionId,
                    player_id: currentEnteredPlayerId
                }, false, false, this, 'requesting').then(awards => {
                    if (!awards || awards.length === 0) {
                        this.playerSpecialAwards = [];
                    } else {
                        this.playerSpecialAwards = awards;
                    }
                });
                this.$normalRequest('player/loadSpecialPlayerMemberAwardsFilteredByCompetitionAndPlayer', {
                    competition_id: currentEnteredCompetitionId,
                    player_id: currentEnteredPlayerId
                }, false, false, this, 'requesting').then(awards => {
                    if (!awards || awards.length === 0) {
                        this.personalSpecialAwards = [];
                    } else {
                        this.personalSpecialAwards = awards;
                    }
                });
            }, 100)
        },
        watch: {
            currentEnteredPlayerId: {
                immediate: true,
                handler () {
                    this.reloadAwards();
                }
            },
            currentEnteredCompetitionId: {
                immediate: true,
                handler () {
                    this.reloadAwards();
                }
            }
        }
    };
</script>
